export enum CloudProjectFolderType {
  OneDrive = 'OneDrive',
  SharePoint = 'SharePoint'
}
